/* © CNES */
import { QueryFunctionContext } from '@tanstack/react-query';
import responseMock from '../mock/response_getFeatureInfo.json';

/**
 * Get all available Processes list from processing service.
 * @param queryKey the query parameters.
 * @returns a Promise of processes list.
 */
export const getFeatureInfo = async ({
  queryKey,
}: QueryFunctionContext<[string]>): Promise<any> => {
  let res: Response | undefined;
  const [url] = queryKey;
  if (process.env.NODE_ENV === 'production') {
    res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } else {
    res = new Response(JSON.stringify(responseMock));
  }

  return res.json();
};
